import { render, staticRenderFns } from "./ShowAnnouncement.vue?vue&type=template&id=5fdd1670&scoped=true"
import script from "./ShowAnnouncement.vue?vue&type=script&lang=js"
export * from "./ShowAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./ShowAnnouncement.vue?vue&type=style&index=0&id=5fdd1670&lang=less"
import style1 from "./ShowAnnouncement.vue?vue&type=style&index=1&id=5fdd1670&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdd1670",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fdd1670')) {
      api.createRecord('5fdd1670', component.options)
    } else {
      api.reload('5fdd1670', component.options)
    }
    module.hot.accept("./ShowAnnouncement.vue?vue&type=template&id=5fdd1670&scoped=true", function () {
      api.rerender('5fdd1670', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tools/ShowAnnouncement.vue"
export default component.exports